import React from "react";
// internal
import title_icon from "assets/img/about/about-me-title-icon.png";
import { ArrowRightThree } from "svg/index";
import { Image } from "react-bootstrap";

const AboutMeInfo = () => {
  return (
    <section className="about__me-info pb-90 pt-110">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-3">
            <span className="about__me-info-subtitle">ABOUT US</span>
          </div>
          <div className="col-xl-8 col-lg-9">
            <div
              className="about__me-info-content wow fadeInUp"
              data-wow-delay=".3s"
              data-wow-duration="1s"
            >
              <h4 className="about__me-info-title">
                Building Digital Experiences That Inspire & Innovate{" "}
                <Image src={title_icon} alt="title icon" />
              </h4>
              <p>
                Rionick Studios is a creative technology company helping businesses transform ideas into immersive digital experiences. From high-end 3D visualization and game development to augmented reality, interactive real estate solutions, branding, and web experiences, we combine creativity with technology to deliver impactful results.
              </p>

              <p>
                Our team specializes in developing scalable solutions for startups, enterprises, creators, and real estate developers. Whether it's creating cinematic CGI, interactive applications, engaging websites, or marketing assets, every project is crafted with precision, innovation, and attention to detail.
              </p>

              <p>
                Driven by quality and innovation, we don't just create visuals—we build experiences that captivate audiences, strengthen brands, and help our clients achieve measurable business growth.
              </p>

              {/* <div className="about__me-info-bottom d-sm-flex align-items-center mt-40">
                <div className="about__me-info-btn mr-30">
                  <a
                    rel="noreferrer"
                    href="https://weblearnbd.net/wp/bioxlab/wp-content/uploads/2022/09/demo-cv.pdf"
                    target="_blank"
                    className="tp-btn"
                  >
                    Download CV
                    <ArrowRightThree />
                  </a>
                </div>
                <div className="about__me-info-social">
                  <a href="#">
                    <i className="fa-brands fa-facebook-f"></i> Facebook
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-twitter"></i> Twitter
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-linkedin-in"></i> LinkedIn
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMeInfo;
